import React from "react";
import { ContentBlock } from "@/types/case-study";

interface LineBreakBlockProps {
  block: ContentBlock;
}

export const LineBreakBlock: React.FC<LineBreakBlockProps> = ({ block }) => {
  return (
    <div className="flex items-center justify-center py-4">
      <div
        className="h-px w-full"
        style={{
          background: 'linear-gradient(90deg, rgba(209, 213, 219, 0.00) 0%, #D1D5DB 50%, rgba(209, 213, 219, 0.00) 100%)'
        }}
      />
    </div>
  );
};